import { Card, CardContent } from "@/components/ui/card";
import { Trophy } from "lucide-react";

export function UnitsTab({ round, totalUnits }) {
  return (
    <Card className="card-default">
      <CardContent className="p-4">
        <h3 className="text-lg font-bold text-[#0F172A] mb-4">Unidades por Jugador</h3>
        <div className="space-y-4">
          {round?.players?.sort((a, b) => (totalUnits[b.player_id] || 0) - (totalUnits[a.player_id] || 0)).map((player, index) => {
            const playerUnits = player.scores?.filter(s => s.has_unit && s.unit_count > 0) || [];
            
            return (
              <div 
                key={player.player_id}
                className={`p-4 rounded-lg ${index === 0 && totalUnits[player.player_id] > 0 ? 'bg-[#D4A373]/10 border border-[#D4A373]/30' : 'bg-gray-50'}`}
              >
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    {index === 0 && totalUnits[player.player_id] > 0 && (
                      <Trophy className="w-5 h-5 text-[#D4A373]" />
                    )}
                    <span className={`w-2 h-2 rounded-full ${player.is_base ? 'bg-[#1B4D3E]' : 'bg-[#D4A373]'}`}></span>
                    <span className="font-semibold text-[#0F172A] truncate max-w-[140px] sm:max-w-none" title={player.name}>{player.name}</span>
                  </div>
                  <span className={`text-2xl font-bold ${totalUnits[player.player_id] > 0 ? 'text-[#D4A373]' : 'text-gray-400'}`}>
                    {totalUnits[player.player_id]}
                  </span>
                </div>
                {playerUnits.length > 0 && (
                  <div className="flex flex-wrap gap-2 mt-2">
                    {playerUnits.map((unit) => (
                      <span 
                        key={`${unit.hole_number}-${unit.unit_type}`}
                        className={`text-xs px-2 py-1 rounded ${
                          unit.unit_type === 'birdie' ? 'bg-green-100 text-green-700' :
                          unit.unit_type === 'sandy' ? 'bg-yellow-100 text-yellow-700' :
                          unit.unit_type === 'oyes' ? 'bg-blue-100 text-blue-700' :
                          'bg-gray-100 text-gray-700'
                        }`}
                      >
                        Hoyo {unit.hole_number}: {unit.unit_type} ({unit.unit_count})
                      </span>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
